/**
 * Imóveis (unidades) de um condomínio — a aba "Imóveis" do cadastro de condomínio. Lista todas as
 * unidades cujo `condominio_id` é este condomínio; cada linha abre o imóvel. Alimentado por
 * GET /cadastro/condominios/{id}/imoveis.
 */
import { Building } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Chip, Spinner } from '@/components/ui/misc';
import { Tabela, Tbody, Td, Th, Thead, Tr } from '@/components/ui/tabela';
import { api, type ImovelCad } from '@/lib/api';

export function PainelImoveisCondominio({ condominioId }: { condominioId: string }) {
  const [imoveis, setImoveis] = useState<ImovelCad[] | null>(null);
  const navegar = useNavigate();

  useEffect(() => {
    let vivo = true;
    void api.get<ImovelCad[]>(`/cadastro/condominios/${condominioId}/imoveis`).then((r) => {
      if (vivo && r.ok) setImoveis(r.dados);
      else if (vivo) setImoveis([]);
    });
    return () => {
      vivo = false;
    };
  }, [condominioId]);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Building className="size-4 text-accent" />
          Imóveis {imoveis && <Chip>{imoveis.length}</Chip>}
        </CardTitle>
        <p className="text-[13px] leading-[1.5] text-text-secondary">
          As unidades vinculadas a este condomínio. Clique para abrir.
        </p>
      </CardHeader>
      <CardContent className="p-0">
        {imoveis === null ? (
          <div className="p-4">
            <Spinner />
          </div>
        ) : imoveis.length === 0 ? (
          <p className="p-4 tipo-corpo-pequeno text-text-tertiary">
            Nenhum imóvel vinculado a este condomínio ainda.
          </p>
        ) : (
          <Tabela>
            <Thead>
              <Th>Identificação</Th>
              <Th>Tipo</Th>
              <Th>Matrícula</Th>
              <Th>Fração ideal</Th>
            </Thead>
            <Tbody>
              {imoveis.map((i) => (
                <Tr key={i.id} onClick={() => navegar(`/cadastro/imoveis/${i.id}`)}>
                  <Td>{i.identificacao || '—'}</Td>
                  <Td>{i.tipo || '—'}</Td>
                  <Td mono>{i.matricula || '—'}</Td>
                  <Td mono>{i.fracao_ideal ?? '—'}</Td>
                </Tr>
              ))}
            </Tbody>
          </Tabela>
        )}
      </CardContent>
    </Card>
  );
}
